import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Import Route Pages
import Home from "../pages/Home";
import AmministrazioneTrasparente from "../pages/AmministrazioneTrasparente";

import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";
import WhistleBlowing from "../pages/WhistleBlowing";

import { AMMINISTRAZIONE_TRASPARENTE_URL, MODELLO_ORGANIZZATIVO_DI_GESTIONE_E_CONTROLLO } from "../constants";
import NeuromotorRehabilitation from "../pages/NeuromotorRehabilitation";
import OrganiztionalManagment from "../pages/OrganizationalManagement";

const BaseRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      {/* Main Route */}
      <Route path="/" element={<Home />} />
      <Route path={AMMINISTRAZIONE_TRASPARENTE_URL} element={<AmministrazioneTrasparente />} />
      <Route path={MODELLO_ORGANIZZATIVO_DI_GESTIONE_E_CONTROLLO} element={<OrganiztionalManagment />} />

      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/whistleblowing" element={<WhistleBlowing />} />
      <Route path="/rehabilitation" element={<NeuromotorRehabilitation />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default BaseRoutes;
